import React, { useMemo } from 'react';
import './AreaAssetGrid.scss';
import CategoryPill from 'src/components/CategoryPill/CategoryPill';
import Empty from 'src/components/Empty';
import {
  IAsset,
  IUnitAreaAsset,
} from 'src/services/api/UnitAreaAssets/apiContracts';
import { filterAreasByQuery } from './helpers';

export interface AreaAssetGridSelection {
  assetId: string;
  assetName: string;
  areaName: string;
}

interface AreaAssetGridProps {
  areas: IUnitAreaAsset[];
  searchQuery?: string;
  selectedAssetId?: string | null;
  isSubmitting?: boolean;
  onSelectAsset?: (selection: AreaAssetGridSelection) => void;
}

const AreaAssetGrid = ({
  areas,
  searchQuery = '',
  selectedAssetId = null,
  isSubmitting = false,
  onSelectAsset,
}: AreaAssetGridProps) => {
  const normalizedSearchQuery: string = searchQuery.toLowerCase().trim();

  const filteredAreas: IUnitAreaAsset[] = useMemo(
    () => filterAreasByQuery(areas, normalizedSearchQuery),
    [areas, normalizedSearchQuery]
  );

  if (filteredAreas.length === 0) {
    return (
      <div className="area-asset-grid-empty-wrapper">
        <Empty
          headline="No assets found"
          strapline="Assets attached to this suite will appear here."
          searchIsActive={normalizedSearchQuery}
          direction={undefined}
          cta={undefined}
          image={
            <img alt="No assets found" src="/assets/empty/documents.svg" />
          }
        />
      </div>
    );
  }

  return (
    <div className="area-asset-grid">
      {filteredAreas.map((area: IUnitAreaAsset) => (
        <div key={area.id} className="area-asset-grid-card">
          <div className="area-asset-grid-card-header">{area.name}</div>
          <div className="area-asset-grid-card-pills">
            {area.assets.map((asset: IAsset) => {
              console.log('area: ', area);

              const isSelected: boolean = selectedAssetId === asset.id;

              return (
                <button
                  key={asset.id}
                  className="area-asset-grid-pill-button"
                  disabled={isSubmitting || !onSelectAsset}
                  onClick={() =>
                    onSelectAsset?.({
                      assetId: asset.id,
                      assetName: asset.item?.name ?? '',
                      areaName: area.name,
                    })
                  }
                >
                  <CategoryPill
                    text={asset.item?.name ?? ''}
                    size="normal"
                    color={isSelected ? '#454F5B' : undefined}
                    textColor={isSelected ? 'white' : undefined}
                  />
                </button>
              );
            })}
          </div>
        </div>
      ))}
    </div>
  );
};

export default AreaAssetGrid;
